import Media from './Media';

export default Media;
export * from './Media';
